import { render, staticRenderFns } from "./InvitationDetailModalSkeleton.vue?vue&type=template&id=1ee13b01&scoped=true"
var script = {}
import style0 from "./InvitationDetailModalSkeleton.vue?vue&type=style&index=0&id=1ee13b01&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee13b01",
  null
  
)

export default component.exports